module.exports = __webpack_public_path__ + "img/coin-click.80530dca.png";